import { gql } from '@apollo/client'

export const SEARCH_QUERY = gql`
    query search(
        $query: String!, 
        $business_units: [String]!, 
        $departments: [String]!, 
        $file_extensions:[String]!,
        $types:[String]!,
        $dates:[String]!,
        $limit: Int, 
        $offset: Int) {
            search(
                query: $query, 
                filter: {
                    conditions: [
                        {
                            field: BUSINESS_UNIT, 
                            value: $business_units, 
                            operator: IN
                        }, {
                            field: DEPARTMENT, 
                            value: $departments, 
                            operator: IN
                        }, {
                            field: FILE_EXTENSION,
                            value: $file_extensions,
                            operator: IN
                        }, {
                            field: TYPE,
                            value: $types,
                            operator: IN
                        }, {
                            field: DATE,
                            value: $dates,
                            operator: IN
                        }
                    ]
                }, 
                limit: $limit, 
                offset: $offset) {
                results {
                    entityType
                    entityBundle
                    entityId
                    entityLabel
                    ... on NodePlaylist {
                        uuid
                        entityChanged
                        isLikedByCurrentUser
                        fieldPlaylistImportedFromSap
                        fieldPlaylistDescription
                        fieldPlaylistItemsCount
                        title
                    }
                    ... on NodeResource {
                        uuid
                        fieldResourceTags{
                            entity{
                                entityLabel
                            }
                        }
                        entityChanged
                        entityId
                        entityLabel
                        entityType
                        fieldResourceDescription
                        fieldResourceFromDate
                        fieldResourceReleaseDate
                        fieldResourceImportedFromSap
                        isLikedByCurrentUser
                        fieldResourceOfflinePeriod {
                            targetId
                        }  
                        fieldResourceFilesByFormat {
                            entity {
                                ... on Media {
                                    uuid
                                    entityChanged
                                    entityLabel
                                    entityType
                                    entityBundle
                                    entityId
                                }
                                ... on MediaMediaFile {
                                    fieldMediaFileLanguage {
                                        value
                                    }
                                    fieldMediaFile {
                                        entity {
                                            ... on File {
                                                uuid
                                                entityChanged
                                                entityChanged
                                                url
                                                filesize
                                                filemime
                                                filename
                                            }
                                        }
                                    }
                                }
                                ... on MediaSapFile {
                                    uuid
                                    entityChanged
                                    entityId
                                    fieldSapFromDate
                                    fieldSapReleaseDate
                                    fieldSapFileFileSize
                                    fieldSapFileFileName
                                    fieldSapFileDocumentVersion
                                    fieldSapFileMime
                                    fieldSapFileLanguage {
                                        value
                                    }
                                    fieldSapFileFileExtension {
                                        entity {
                                            ... on TaxonomyTermFileExtension {
                                                fieldFileExtensionValue
                                            }
                                        }
                                    }
                                }
                                ... on MediaMasterControl {
                                   uuid
                                   entityChanged
                                   entityId
                                   fieldMasterControlId
                                   fieldMasterControlCategory
                                   fieldMasterControlDescription
                                   fieldMasterControlTitle
                                   fieldMasterControlRevision
                                   fieldMasterControlMime
                                   fieldMasterControlSize
                                   fieldMasterControlExtension {
                                    entity {
                                      ... on TaxonomyTermFileExtension {
                                        fieldFileExtensionValue
                                      }
                                    }
                                   }
                                }
                                ... on MediaMasterControlAttachment {
                                   uuid
                                   entityChanged
                                   entityId
                                   fieldMcAttachmentId
                                   fieldMcAttachmentName
                                   fieldMcAttachmentDescription
                                   fieldMcAttachmentMime
                                   fieldMcAttachmentSize
                                   fieldMcAttachmentExtension {
                                    entity {
                                      ... on TaxonomyTermFileExtension {
                                        fieldFileExtensionValue
                                      }
                                    }
                                   }
                                }
                                ... on MediaBokeccVideo {
                                    fieldBokeccIframe
                                }
                               ... on MediaExternalLink{
                                fieldExternalLinkLink{
                                  url {
                                    path
                                  }
                                }
                              }
                            }
                        }
			        }
		        }
	        }
        }
    `;
